import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDatePicker from "react-datepicker";
import { useColorMode } from "@chakra-ui/react";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.css";
var DatePicker = function(_param) {
    var selectedDate = _param.selectedDate, onChange = _param.onChange, _isClearable = _param.isClearable, isClearable = _isClearable === void 0 ? false : _isClearable, _showPopperArrow = _param.showPopperArrow, showPopperArrow = _showPopperArrow === void 0 ? false : _showPopperArrow, utcOffset = _param.utcOffset, props = _object_without_properties(_param, [
        "selectedDate",
        "onChange",
        "isClearable",
        "showPopperArrow",
        "utcOffset"
    ]);
    var isLight = useColorMode().colorMode === "light"; //you can check what theme you are using right now however you want
    return(// if you don't want to use chakra's colors or you just wwant to use the original ones,
    // set className to "light-theme-original" ↓↓↓↓
    /*#__PURE__*/ _jsx("div", {
        className: isLight ? "light-theme" : "dark-theme",
        children: /*#__PURE__*/ _jsx(ReactDatePicker, _object_spread({
            selected: selectedDate,
            onChange: onChange,
            isClearable: isClearable,
            showPopperArrow: showPopperArrow,
            className: "react-datapicker__input-text" //input is white by default and there is no already defined class for it so I created a new one
            ,
            utcOffset: utcOffset
        }, props))
    }));
};
export default DatePicker;
